module.exports = __webpack_public_path__ + "img/wy.bcd0fd91.png";